import { render, staticRenderFns } from "./CardSumToPayPie.vue?vue&type=template&id=425b51d6&scoped=true"
import script from "./CardSumToPayPie.vue?vue&type=script&lang=js"
export * from "./CardSumToPayPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425b51d6",
  null
  
)

export default component.exports